export default __webpack_public_path__ + "static/media/toastrErrorIcon.1731e43e.svg";